export const isNurseUser = (user: any): boolean =>
  user?.role?.toLowerCase() === "nurse";

export const isAdvocateUser = (user: any): boolean =>
  Boolean(user?.role?.toLowerCase?.().includes("advocate"));

// Matches "frontdesk", "front-desk", "front_desk" and "front desk".
export const isFrontDeskUser = (user: any): boolean =>
  /front[\s_-]?desk/i.test(user?.role ?? "");

// Advocates and front desk staff can pick any provider at their location, but
// start with none picked and see only their own data until they do. The EHR
// dashboard is the exception: it shows every provider at the location until then.
export const startsWithNoProviders = (user: any): boolean =>
  isAdvocateUser(user) || isFrontDeskUser(user);

export const isMedicalDirectorUser = (user: any): boolean =>
  user?.role === "medical-director";

// A provider in the clinical sense. Nurses with a PROVIDER role type are
// excluded, and so is the medical director, whose patient list stays
// unscoped as before.
export const isBreakGlassProvider = (user: any): boolean =>
  user?.roleType === "PROVIDER" &&
  !isNurseUser(user) &&
  !isMedicalDirectorUser(user);

// Reviewing who broke the glass is an oversight job, so the audit log stays
// with the roles that already see every patient.
export const canViewBreakGlassAuditLogs = (user: any): boolean =>
  user?.roleType === "ADMIN_USER" || isMedicalDirectorUser(user);

export interface BreakGlassParams {
  breakGlassUuid?: string;
  isProvider?: boolean;
}

export const getBreakGlassParams = (user: any): BreakGlassParams => {
  if (!user?.uuid) return {};
  if (isNurseUser(user)) {
    return { breakGlassUuid: user.uuid, isProvider: false };
  }
  if (isBreakGlassProvider(user)) {
    return { breakGlassUuid: user.uuid, isProvider: true };
  }
  return {};
};

// Who is breaking the glass, as the break glass API expects it: a nurse is
// sent as `nurseStaffProviderUuid`, a provider as `providerUuid`.
export const getBreakGlassActor = (
  user: any,
): { providerUuid?: string; nurseStaffProviderUuid?: string } => {
  if (!user?.uuid) return {};
  return isNurseUser(user)
    ? { nurseStaffProviderUuid: user.uuid }
    : { providerUuid: user.uuid };
};
